export function formatCardBrandLabel(brand: string | null | undefined): string {
  if (!brand) return "Card"
  const normalized = brand.trim().toLowerCase()
  const map: Record<string, string> = {
    visa: "Visa",
    mastercard: "Mastercard",
    amex: "American Express",
    american_express: "American Express",
    discover: "Discover",
    diners: "Diners Club",
    diners_club: "Diners Club",
    jcb: "JCB",
    unionpay: "UnionPay",
  }
  if (map[normalized]) return map[normalized]
  return brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase()
}

/** Unambiguous calendar date (matches Stripe billing portal style, avoids DD/MM vs MM/DD confusion). */
export function formatBillingHistoryStatus(
  status: string | null | undefined,
  t: (key: string) => string
): string {
  const normalized = String(status || "").trim().toLowerCase()
  if (normalized === "paid" || normalized === "succeeded") return t("billing.historyStatusPaid")
  if (normalized === "open") return t("billing.historyStatusOpen")
  if (normalized === "void") return t("billing.historyStatusVoid")
  if (normalized === "uncollectible") return t("billing.historyStatusUncollectible")
  if (!normalized) return t("billing.nA")
  return normalized.charAt(0).toUpperCase() + normalized.slice(1)
}

export function formatBillingCalendarDate(iso: string | null | undefined): string {
  if (!iso) return ""
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ""
  return d.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })
}
